import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {NatRentAdminContactAddress} from '../NatResidentApplicationInterface'
import {HAVE_OR_NOT} from '../../../../../CodeMaster'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {getFormattedAddress} from '../helper/NatContactAddressOnEmergencyHelper'

interface Props {
    rentAdminContactAddressFlag: Nullable<string>
    rentAdminContactAddress: Nullable<NatRentAdminContactAddress>
}

const NatResidentRentAdminContactAddressConfirmView = (props: Props) => {
    const {
        rentAdminContactAddressFlag, rentAdminContactAddress
    } = props

    if (!rentAdminContactAddress ||
        !rentAdminContactAddressFlag ||
        rentAdminContactAddressFlag === HAVE_OR_NOT.NOT.value) {
        return <></>
    }

    const {
        name, zipCode, prefecture, address2,
        address3, buildingRoomNumber, phoneNumber
    } = rentAdminContactAddress

    const items = []
    items.push(`名称：${name}`)
    items.push(`電話番号：${phoneNumber}`)
    items.push(`住所： ${getFormattedAddress(zipCode, prefecture, address2, address3, buildingRoomNumber)}`)

    return (<>
        <NatResidentApplicationDetailConfirmItem
            title={'賃貸管理者連絡先（仲介業者など）'}
            items={items}
        />
        <BlockSpacer height={'5px'}/>
    </>)
}

NatResidentRentAdminContactAddressConfirmView.displayName = 'NatResidentRentAdminContactAddressConfirmView'
export default NatResidentRentAdminContactAddressConfirmView